// extracted by mini-css-extract-plugin
export default {"yesnobutton":"yesno_yesnobutton__vR4ZW","wrong":"yesno_wrong__azmdB","shake":"yesno_shake__CYvo3","wordimage":"yesno_wordimage__I1X7Y","yesnocard":"yesno_yesnocard__mhcrv"};